import { render, staticRenderFns } from "./DeviceDetect.vue?vue&type=template&id=2469b968&"
import script from "./DeviceDetect.ts?vue&type=script&lang=ts&"
export * from "./DeviceDetect.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports